import { store, persistor } from './root-store';
export const RootStore = {
  store,
  persistor,
};
